





















import { Component, Prop } from "vue-property-decorator";

import CommitteeComponent from "@share/committees/committee/Committee.vue";
import TicketViewOrEditPart from "@service/views/committees/TicketViewOrEditPart.vue";
import CommitteeViewWithTicket from "@service/views/committees/ViewWithTicket.vue";

import { CommitteeModelInterface } from "@api/models/interfaces/committees/CommitteeModelInterface";
import { TicketRowInterfaceView } from "@share/committees/common/types/interfaces/TicketsRowInterface";

@Component({ components: { CommitteeComponent, TicketViewOrEditPart } })
export default class CommitteeView extends CommitteeViewWithTicket<TicketRowInterfaceView> {
    @Prop() committee: CommitteeModelInterface | null;

}
